/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Background_DownloadInputs */

const en_mobile_background_download = /** @type {(inputs: Mobile_Background_DownloadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Background Download`)
};

const es_mobile_background_download = /** @type {(inputs: Mobile_Background_DownloadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descarga en segundo plano`)
};

/**
* | output |
* | --- |
* | "Background Download" |
*
* @param {Mobile_Background_DownloadInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_background_download = /** @type {((inputs?: Mobile_Background_DownloadInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Background_DownloadInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_background_download(inputs)
	return en_mobile_background_download(inputs)
});